import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';

const HeadC = dynamic(() => import('src/components/Head'));
const TenagaKesehatanContainer = dynamic(() => import('src/containers/TenagaKesehatan'));

const TenagaKesehatan = () => {
	return (
		<>
			<HeadC
				title="Kerja Sama Tenaga Kesehatan di KlikDokter"
				description={
					'Mari bersinergi dan menjadi Mitra Tenaga Kesehatan di KlikDokter. ' +
					'Ajukan Layanan kerja sama dan Layanan iklan berbayar di sini. '
				}
			/>
			<TenagaKesehatanContainer />
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	await store.dispatch(actionGetMenu());
	await store.dispatch(actionGetFooterMenu());

	return {
		props: {
			pageHeaderContent: {
				breadcrumbs: [{ label: 'Korporasi' }],
			},
		},
	};
});

export default TenagaKesehatan;
